import { Box } from "@material-ui/core";
import { useContext } from "react";
import AutorizacaoEspecialAttachmentDataComponent from "../../../components/materialui/AutorizacaoEspecial/AutorizacaoEspecialAttachmentDataComponent";
import FormBase from "../../../../forms/FormBase";
import Steps from "../../../../components/steps/Steps";
import FormFieldAttachmentBase, { FieldAttachment } from "../../../../forms/FormFieldAttachmentBase";
import { AutorizacaoEspecialContext } from "../../../../context/AutorizacaoEspecialContext";

export default function AutorizacaoEspecialAttachmentDataStep() {

    const { state, dispatch, updateFile, deleteFile } = useContext(AutorizacaoEspecialContext);

    const onInputAttachmentChange = (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => {
        dispatch({
            type: "UPDATE_FORM_ATTACHMENT",
            payload: { form, value: fieldAttachment, name, subType: "Insert", id: ""},
        });
        updateFile(name, form, fieldAttachment, formField);
    };

    const onDeleteAttachmentChange = (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => {
        deleteFile(name, form, fieldAttachment, formField);
    };

    return (
        <div>
            <Steps.StepTitle text="Anexos" />

            <Box mt={2}>
                <AutorizacaoEspecialAttachmentDataComponent 
                    ParticipationRequestForm={state.ParticipationRequestForm}
                    AutorizacaoEspecialAttachmentForm={state.AttachmentForm} 
                    onInputChange={onInputAttachmentChange} 
                    onDeleteFile={onDeleteAttachmentChange} />
            </Box>
        </div>
    );
}